import type { SocialCaptureResponse } from "contracts/api/social/admin";
import { For, Show } from "solid-js";
import { citedEvidence } from "./socialReportModel";

type Catalog = NonNullable<SocialCaptureResponse["analysis"]>["evidence"];

/**
 * The evidence a conclusion cites, resolved against the attempt's catalog so
 * the reader sees what each key refers to. An unresolved key still renders —
 * the citation is part of the record.
 */
export function SocialReportEvidence(props: {
  keys: string[];
  catalog: Catalog;
}) {
  return (
    <ul class="social-report-evidence-cites">
      <For each={citedEvidence(props.keys, props.catalog)}>
        {(cited) => (
          <li>
            <code>{cited.key}</code>
            <Show when={cited.evidence} keyed>
              {(evidence) => (
                <>
                  <span>{evidence.description}</span>
                  <Show when={evidence.excerpt} keyed>
                    {(excerpt) => <q>{excerpt}</q>}
                  </Show>
                </>
              )}
            </Show>
          </li>
        )}
      </For>
    </ul>
  );
}
